import React, { useContext, useEffect, useState } from 'react';
import './PersonalInfo.scss';
import Title from 'antd/lib/typography/Title';
import { User } from '../../model/User';
import { Context } from '../../index';

const PersonalInfo = (): JSX.Element => {
  const [user, setUser] = useState<User | null>(null);
  const { store } = useContext(Context);

  useEffect(() => {
    const userId = store.getUserId();
    if (userId) {
      store.getCurrentUserInfo(userId).then((resp) => {
        if (resp) {
          setUser(resp);
        }
      });
    }
  }, []);

  return (
    <div className="personalInfo">
      <Title className="personalInfo__title" level={2}>
        {user?.lastName + ' ' + user?.firstName + ' ' + user?.middleName}
      </Title>
      <div className="personalInfo__info">
        <label>Электронная почта</label>
        <div>{user?.email}</div>
      </div>
      {user?.phone && (
        <div className="personalInfo__info">
          <label>Телефон</label>
          <div>{user?.phone}</div>
        </div>
      )}
    </div>
  );
};

export default PersonalInfo;
